export const VIRTUAL_PROVIDER = "VIRTUAL" as const;
export const RETURN_BEAR_PROVIDER = "RETURN_BEAR" as const;
export const BLUE_YONDER_PROVIDER = "BLUE_YONDER" as const;

export const dropoffProviderType = [
  VIRTUAL_PROVIDER,
  RETURN_BEAR_PROVIDER,
  BLUE_YONDER_PROVIDER,
  // "HAPPY_RETURNS",
] as const;
export type DropoffProviderType = (typeof dropoffProviderType)[number];
export const DropoffProviderType = dropoffProviderType;

const merchantFacingProviderNames: Record<DropoffProviderType, string> = {
  VIRTUAL: "Virtual",
  RETURN_BEAR: "ReturnBear",
  BLUE_YONDER: "FedEx Easy Returns",
};

export function getMerchantFacingProviderName(
  provider: DropoffProviderType,
): string {
  return merchantFacingProviderNames[provider];
}

export const DEFAULT_DROPOFF_RADIUS_MILES = 50;

/**
 * Flat-rate fee (USD) charged for a dropoff provider when no fee is stored on
 * the draft return. `null` means the provider does not have a static default
 * and its fee must be resolved through another path (e.g. ReturnBear's
 * `getReturnBearFallbackFlatRateFee` rate table).
 */
export const defaultDropoffFeeUsd = {
  VIRTUAL: 5,
  BLUE_YONDER: 6,
  RETURN_BEAR: null,
} as const satisfies Record<DropoffProviderType, number | null>;

export const DEFAULT_VIRTUAL_DROPOFF_FEE_USD = defaultDropoffFeeUsd.VIRTUAL;
export const DEFAULT_BLUE_YONDER_DROPOFF_FEE_USD =
  defaultDropoffFeeUsd.BLUE_YONDER;
